import {
  Grid,
  TextField,
  FormHelperText,
  Box,
  useTheme,
  Button,
  Typography,
} from "@mui/material";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import Header from "../../components/Header";
import { tokens } from "../../theme";

const ZoomMeetingDetails = ({
  onHandleZoomMeetingDetailsInputChange,
  zoomMeetingDetails,
}) => {
  return (
    <Box m="40px" ml="60px">
      <Header title="Zoom Meeting Details" subtitle="Fill the required field" />
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <TextField
            name="zoomMeetingId"
            label="Enter the Zoom Meeting Id"
            variant="outlined"
            type="text"
            fullWidth
            sx={{ mt: 1, boxShadow: 2 }}
            value={zoomMeetingDetails.zoomMeetingId}
            onChange={onHandleZoomMeetingDetailsInputChange}
            required
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            name="zoomMeetingPasscode"
            label="Enter the Zoom Meeting Password"
            variant="outlined"
            type="text"
            fullWidth
            required
            sx={{ boxShadow: 2 }}
            value={zoomMeetingDetails.zoomMeetingPasscode}
            onChange={onHandleZoomMeetingDetailsInputChange}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ZoomMeetingDetails;
